import React from 'react'
import { Link } from 'react-router-dom'
import { iBack, iComponent } from '../../utilities/ImageImports'

const CommonSectionTitle = ({
    title = '',
    titleIcon = '',
    withBackLink = false,
    backLinkUrl = '',
    defaultIcon = iComponent,
}) => {
    return (
        <div className='flex items-center justify-between space-x-2 text-lg sm:text-xl text-gray-500 dark:text-cDarkText2 font-semibold tracking-widest w-full text-left drop-shadow-md uppercase'>
            {withBackLink ?
                <Link to={backLinkUrl} >
                    <img className='w-[20px] h-[20px]' src={iBack} alt="" />
                </Link>
                : ''}
            <div className='flex items-center space-x-4'>
                <img src={titleIcon ? titleIcon : defaultIcon} alt='icon-for-title' className='w-[15px] h-[15px]' />
                <div>{title}</div>
            </div>
            <div></div>
        </div>
    )
}

export default CommonSectionTitle
